import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TRACTORCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TractorCategory.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const TRACTORCATEGORY_CONFIG = {
  entityName: 'TractorCategory',
  localizationKey: 'General::Entity.TractorCategory',
  fields: TRACTORCATEGORY_FIELDS,
  permission: 'GeneralMachinesAndVehicles.TractorCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
